/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ average: NonNullable<unknown>, previous: NonNullable<unknown> }} Practice_Trend_BetterInputs */



/**
* | output |
* | --- |
* | "Average {average} — better than {previous}" |
*
* @param {Practice_Trend_BetterInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_trend_better = /** @type {((inputs: Practice_Trend_BetterInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Trend_BetterInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gemiddelde ${i?.average} — beter dan ${i?.previous}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Moyenne ${i?.average} — mieux que ${i?.previous}`)
	return /** @type {LocalizedString} */ (`Average ${i?.average} — better than ${i?.previous}`)
});